export const maintenanceUserTypes = {
  ZONE_LEAD: 'zone_lead',
};
